import { z } from 'zod';

export const disableTmaisUserSchema = z.object({
  disable_reason: z.string({ message: 'Campo obrigatório' }).min(1, { message: 'Campo obrigatório' }),
});

export type DisableTmaisUserValidationSchema = z.infer<typeof disableTmaisUserSchema>;
